export const VARIABILI_BASE = {
  STRADARIO_ABILITATO: 'stradario.abilitato',
}